import axiosHttp from '@/http-common'

class OperationDataService {
    getData(url) {
      return axiosHttp.http.get(url)
    }
  }
  
export default new OperationDataService();